import type { SelectHTMLAttributes } from 'react';

import { cx } from '../lib/cx.ts';
import { useFieldState } from './Field.tsx';
import { controlClasses } from './TextInput.tsx';

type Option = { value: string; label: string };

type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className' | 'children'> & {
  options: readonly Option[];
  /** Rendered first, with an empty value. Omit for a select that must have one. */
  placeholder?: string;
  className?: string;
};

export function Select({ options, placeholder, className, ...rest }: SelectProps) {
  const field = useFieldState();

  return (
    <select
      id={field?.inputId}
      aria-describedby={field?.describedBy}
      aria-invalid={field?.invalid || undefined}
      className={cx(controlClasses, 'appearance-none pr-8', className)}
      {...rest}
    >
      {placeholder === undefined ? null : <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
